var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPrinterBlue = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Printer") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Printer",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Header/Printer",
    transform: "translate(1.0067B9, 1.0067B9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.450000, 0.450000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9991907,10.2880465 C24.6295163,10.2880465 25.1400279,10.7985581 25.1400279,11.4288837 C25.1400279,12.0592093 24.6295163,12.5697209 23.9991907,12.5697209 C23.3688651,12.5697209 22.8583535,12.0592093 22.8583535,11.4288837 C22.8583535,10.7985581 23.3688651,10.2880465 23.9991907,10.2880465",
    id: "Fill-1",
    fill: "#0067B9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    stroke: "#0067B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    points: "22 7.99627907 22 -3.36619621e-13 5 -3.36619621e-13 5 8.00148837"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5",
    stroke: "#0067B9",
    strokeWidth: 2,
    strokeLinecap: "round",
    points: "5 26.9967907 22 26.9967907 22 15.9967907 5 15.9967907"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.06141829,22.0010326 L1.12305026,22.0010326 C0.502552171,22.0010326 0,21.5006679 0,20.8828706 L0,9.11919448 C0,8.50203548 0.502552171,8.00103256 1.12305026,8.00103256 L25.8763087,8.00103256 C26.4968068,8.00103256 27,8.50203548 27,9.11919448 L27,20.8828706 C27,21.5006679 26.4968068,22.0010326 25.8763087,22.0010326 L21.9379407,22.0010326",
    id: "Stroke-7",
    stroke: "#0067B9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.430893,
    y1: 19.425293,
    x2: 8.00168372,
    y2: 19.425293,
    id: "Stroke-8",
    stroke: "#0067B9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.430893,
    y1: 23.15025,
    x2: 8.00168372,
    y2: 23.15025,
    id: "Stroke-10",
    stroke: "#0067B9",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPrinterBlue);
export default ForwardRef;